import { render, staticRenderFns } from "./supplier_boss_home.vue?vue&type=template&id=06ebdbbe"
import script from "./supplier_boss_home.vue?vue&type=script&lang=js"
export * from "./supplier_boss_home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports